import sideNavDo1 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-do-1.png";
import sideNavDont1 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-dont-1.png";
import sideNavDo2 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-do-2.png";
import sideNavDont2 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-dont-2.png";
import sideNavDo3 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-do-3.png";
import sideNavDont3 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-dont-3.png";
import sideNavDo4 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-do-4.png";
import sideNavDont4 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-dont-4.png";
import sideNavDo5 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-do-5.png";
import sideNavDont5 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-dont-5.png";
import sideNavDo6 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-do-6.png";
import sideNavDont6 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-dont-6.png";
import sideNavDo7 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-do-7.png";
import sideNavDont7 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-dont-7.png";
import sideNavDont8 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-dont-8.png";
import sideNavDont9 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-dont-9.png";
import sideNavDont10 from "../../../../../../packages/design-system/navigation-system/constellation/side-nav-items/images/side-nav-dont-10.png";
import * as React from 'react';
export default {
  sideNavDo1,
  sideNavDont1,
  sideNavDo2,
  sideNavDont2,
  sideNavDo3,
  sideNavDont3,
  sideNavDo4,
  sideNavDont4,
  sideNavDo5,
  sideNavDont5,
  sideNavDo6,
  sideNavDont6,
  sideNavDo7,
  sideNavDont7,
  sideNavDont8,
  sideNavDont9,
  sideNavDont10,
  React
};